// extracted by mini-css-extract-plugin
export var copyableField = "_if-4";
export var customerBadge = "_if-0";
export var customerInfoTitle = "_if-2";
export var details = "_if-1";
export var dropdownContainer = "_if-5";
export var dropdownImage = "_if-6";
export var editAssigneeForm = "_if-a";
export var editButton = "_if-3";
export var email = "_if-7";
export var hidden = "_if-d";
export var input = "_if-8";
export var saveButton = "_if-b";
export var shopifyIcon = "_if-c";
export var suggestionBadge = "_if-e";
export var suggestionText = "_if-f";
export var username = "_if-9";